import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ui-product-not-orderable',
  template: '<span class="badge">Derzeit nicht bestellbar</span>',
  styleUrl: './product-not-orderable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductNotOrderableComponent {
}
